export interface IGraphQLResponse<T> {
  data: T;
}

export enum ToastTypes {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
  BLANK = 'BLANK',
  CUSTOM = 'CUSTOM',
}

export enum UserPermissionType {
  COACH_MODULE_VIEW_ACTIVE_COACHES = 'COACH_MODULE_VIEW_ACTIVE_COACHES',
  COACH_MODULE_VIEW_ARCHIVE_COACHES = 'COACH_MODULE_VIEW_ARCHIVE_COACHES',
  COACH_MODULE_DELETE_COACH = 'COACH_MODULE_DELETE_COACH',
  COACH_MODULE_UPDATE_COACH_STATUS = 'COACH_MODULE_UPDATE_COACH_STATUS',

  ACTIVITY_LIBRARY_MODULE_GET_ACTIVITY_LIBRARY = 'ACTIVITY_LIBRARY_MODULE_GET_ACTIVITY_LIBRARY',
  ACTIVITY_LIBRARY_MODULE_CREATE_ACTIVITY_LIBRARY = 'ACTIVITY_LIBRARY_MODULE_CREATE_ACTIVITY_LIBRARY',
  ACTIVITY_LIBRARY_MODULE_UPDATE_ACTIVITY_LIBRARY = 'ACTIVITY_LIBRARY_MODULE_UPDATE_ACTIVITY_LIBRARY',
  ACTIVITY_LIBRARY_MODULE_DELETE_ACTIVITY_LIBRARY = 'ACTIVITY_LIBRARY_MODULE_DELETE_ACTIVITY_LIBRARY',

  CORE_MODULE_VIEW_USER_GROUPS = 'CORE_MODULE_VIEW_USER_GROUPS',
  CORE_MODULE_GET_CLIENTS = 'CORE_MODULE_GET_CLIENTS',
  CORE_MODULE_VIEW_ARCHIVE_CLIENTS = 'CORE_MODULE_VIEW_ARCHIVE_CLIENTS',
  CORE_MODULE_CHANGE_CLIENT_STATUS = 'CORE_MODULE_CHANGE_CLIENT_STATUS',
  CORE_MODULE_ARCHIVE_CLIENTS = 'CORE_MODULE_ARCHIVE_CLIENTS',
  CORE_MODULE_ADD_NEW_CLIENT = 'CORE_MODULE_ADD_NEW_CLIENT',
  CORE_MODULE_CHANGE_LANGUAGE = 'CORE_MODULE_CHANGE_LANGUAGE',
  CORE_MODULE_SEND_ACTIVITY_SUMMARY = 'CORE_MODULE_SEND_ACTIVITY_SUMMARY',
  CORE_MODULE_VIEW_SINGLE_CLIENT = 'CORE_MODULE_VIEW_SINGLE_CLIENT',
  CORE_MODULE_VIEW_CLIENT_CONCENT = 'CORE_MODULE_VIEW_CLIENT_CONCENT',
  CORE_MODULE_UPDATE_CLIENT_OBJECTIVES = 'CORE_MODULE_UPDATE_CLIENT_OBJECTIVES',
  CORE_MODULE_UPDATE_CLIENT_CONCENT = 'CORE_MODULE_UPDATE_CLIENT_CONCENT',
  CORE_MODULE_VIEW_APP_SETTINGS = 'CORE_MODULE_VIEW_APP_SETTINGS',
  CORE_MODULE_UPDATE_APP_SETTINGS = 'CORE_MODULE_UPDATE_APP_SETTINGS',
  CORE_MODULE_COACH_DATA_REQUEST = 'CORE_MODULE_COACH_DATA_REQUEST',
  CORE_MODULE_DELETE_COACH_ACCOUNT = 'CORE_MODULE_DELETE_COACH_ACCOUNT',

  PROGRESS_MODULE_GET_PROGRESS_SUMMARY = 'PROGRESS_MODULE_GET_PROGRESS_SUMMARY',

  NOTIFICATION_MODULE_VIEW_NOTIFICATIONS = 'NOTIFICATION_MODULE_VIEW_NOTIFICATIONS',

  NOTE_MODULE_VIEW_NOTES = 'NOTE_MODULE_VIEW_NOTES',
  NOTE_MODULE_CREATE_AND_EDIT_NOTES = 'NOTE_MODULE_CREATE_AND_EDIT_NOTES',
  NOTE_MODULE_DELETE_NOTES = 'NOTE_MODULE_DELETE_NOTES',
  NOTE_MODULE_USE_RECORDING = 'NOTE_MODULE_USE_RECORDING',

  // Magic suggestion Permissions
  MAGIC_SUGGESTIONS_MODULE_GENERATE_SUGGESTIONS = 'MAGIC_SUGGESTIONS_MODULE_GENERATE_SUGGESTIONS',
  MAGIC_SUGGESTIONS_MODULE_VIEW_SUGGESTIONS = 'MAGIC_SUGGESTIONS_MODULE_VIEW_SUGGESTIONS',

  CHAT_MODULE_VIEW_CHAT = 'CHAT_MODULE_VIEW_CHAT',
  CHAT_MODULE_SEND_MESSAGE = 'CHAT_MODULE_SEND_MESSAGE',

  BOOKINGS_MODULE_VIEW_BOOKINGS = 'BOOKINGS_MODULE_VIEW_BOOKINGS',
  BOOKINGS_MODULE_MANAGE_BOOKINGS = 'BOOKINGS_MODULE_MANAGE_BOOKINGS',
  BOOKINGS_MODULE_VIEW_COACH_CONFIGURATIONS = 'BOOKINGS_MODULE_VIEW_COACH_CONFIGURATIONS',
  BOOKINGS_MODULE_MANAGE_COACH_CONFIGURATIONS = 'BOOKINGS_MODULE_MANAGE_COACH_CONFIGURATIONS',

  ACTIVITY_MODULE_VIEW_ACTIVITIES = 'ACTIVITY_MODULE_VIEW_ACTIVITIES',
  ACTIVITY_MODULE_ASSIGN_NEW_ACTIVITY = 'ACTIVITY_MODULE_ASSIGN_NEW_ACTIVITY',
  ACTIVITY_MODULE_CHANGE_ACTIVITY_STATUS = 'ACTIVITY_MODULE_CHANGE_ACTIVITY_STATUS',
  ACTIVITY_MODULE_EDIT_ACTIVITY = 'ACTIVITY_MODULE_EDIT_ACTIVITY',

  AQUARIUM_MODULE_VIEW_AQUARIUM = 'AQUARIUM_MODULE_VIEW_AQUARIUM',
  AQUARIUM_MODULE_UPDATE_AQUARIUM = 'AQUARIUM_MODULE_UPDATE_AQUARIUM',

  CHAT_SUPPORT_MODULE_PERMISSION = 'CHAT_SUPPORT_MODULE_PERMISSION',

  CLIENT_ACTIVITY_MODULE_UPDATE_ACTIVITY = 'CLIENT_ACTIVITY_MODULE_UPDATE_ACTIVITY',
  CLIENT_ACTIVITY_MODULE_CREATE_ACTIVITY = 'CLIENT_ACTIVITY_MODULE_CREATE_ACTIVITY',
  CLIENT_ACTIVITY_MODULE_DELETE_ACTIVITY = 'CLIENT_ACTIVITY_MODULE_DELETE_ACTIVITY',

  // manage group coaching permissions
  TEAM_MODULE_ARCHIVE_TEAM_MEMBER = 'TEAM_MODULE_ARCHIVE_TEAM_MEMBER',
  TEAM_MODULE_ADD_TEAM_MEMBER = 'TEAM_MODULE_ADD_TEAM_MEMBER',
  TEAM_MODULE_VIEW_COACH_GROUP = 'TEAM_MODULE_VIEW_COACH_GROUP',
  TEAM_MODULE_EDIT_TEAM_MEMBER = 'TEAM_MODULE_EDIT_TEAM_MEMBER',

  // Client Group Module Permissions
  CLIENT_GROUP_MODULE_EDIT_CLIENT_GROUP = 'CLIENT_GROUP_MODULE_EDIT_CLIENT_GROUP',
  CLIENT_GROUP_MODULE_DELETE_CLIENT_GROUP = 'CLIENT_GROUP_MODULE_DELETE_CLIENT_GROUP',
  CLIENT_GROUP_MODULE_VIEW_CLIENT_GROUP = 'CLIENT_GROUP_MODULE_VIEW_CLIENT_GROUP',
}

export enum ModuleType {
  MAGIC_SUGGESTIONS_MODULE = 'MAGIC_SUGGESTIONS_MODULE',
  CORE_MODULE = 'CORE_MODULE',
  NOTE_MODULE = 'NOTE_MODULE',
  ACTIVITY_MODULE = 'ACTIVITY_MODULE',
  COACH_MODULE = 'COACH_MODULE',
  PROGRESS_MODULE = 'PROGRESS_MODULE',
  CHAT_MODULE = 'CHAT_MODULE',
  NOTIFICATION_MODULE = 'NOTIFICATION_MODULE',
  ACTIVITY_LIBRARY_MODULE = 'ACTIVITY_LIBRARY_MODULE',
  AQUARIUM_MODULE = 'AQUARIUM_MODULE',
  CHAT_SUPPORT_MODULE = 'CHAT_SUPPORT_MODULE',
  CLIENT_ACTIVITY_MODULE = 'CLIENT_ACTIVITY_MODULE',
  TEAM_MODULE = 'TEAM_MODULE',
  CLIENT_GROUP_MODULE = 'CLIENT_GROUP_MODULE',
}
